import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').AdminUser[]>}
 */
export async function fetchUsers() {
  const { data } = await api.get('/admin/users')
  return data.data.users
}

/**
 * @returns {Promise<import('@/types/api').AdminRole[]>}
 */
export async function fetchRoles() {
  const { data } = await api.get('/admin/roles')
  return data.data.roles
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<import('@/types/api').AdminUser>}
 */
export async function createUser(payload) {
  const { data } = await api.post('/admin/users', payload)
  return data.data.user
}

/**
 * @param {number} userId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<import('@/types/api').AdminUser>}
 */
export async function updateUser(userId, payload) {
  const { data } = await api.put(`/admin/users/${userId}`, payload)
  return data.data.user
}
